import type { AxiosResponse } from 'axios';

/**
 * Read a response header as a plain string.
 *
 * Axios 1.x types `res.headers[key]` as `AxiosHeaderValue`
 * (string | number | boolean | null | undefined | string[] | AxiosHeaders),
 * which no longer assigns to `string`. This normalizes any header value
 * to a string, with an optional fallback for missing headers.
 */
export const headerStr = (res: AxiosResponse, key: string, fallback = ''): string => {
  const value = res.headers?.[key] ?? res.headers?.[key.toLowerCase()];
  return value == null ? fallback : String(value);
};
